import { ReactElement } from 'react';
import classnames from 'classnames';
import noop from 'lodash/fp/noop';
import { format } from 'date-fns/fp';

export interface DayProps {
	date: Date;
	tabIndex?: number;
	ariaLabel?: string;
	isSelected?: boolean;
	isSelectedStart?: boolean;
	isSelectedEnd?: boolean;
	isRestricted?: boolean;
	isUnavailable?: boolean;
	disabled?: boolean;

	onClick?: () => void;
}

export default function Day({
	date,
	tabIndex,
	ariaLabel,
	isSelected = false,
	isSelectedStart = false,
	isSelectedEnd = false,
	isRestricted = false,
	isUnavailable = false,
	disabled = false,

	onClick = noop,
}: DayProps): ReactElement {
	return (
		<td
			className={classnames('CalendarDay_container', {
				'CalendarDay__selected_start CalendarDay__selected': isSelectedStart,
				'CalendarDay__selected_end CalendarDay__selected': isSelectedEnd,
				'CalendarDay__selected_span CalendarDay__selected': isSelected,
				CalendarDay__blocked_out_of_range: disabled,
				CalendarDay__highlighted_calendar: isRestricted,
				Day__blocked_calendar: isUnavailable,
			})}
		>
			<button
				className={`CalendarDay_button CalendarDay_button_${format('yyyy-MM-dd')(date)}`}
				type="button"
				aria-label={ariaLabel}
				aria-selected={isSelected || isSelectedStart || isSelectedEnd}
				tabIndex={tabIndex}
				disabled={disabled}
				onClick={() => onClick()}
			>
				{format('d')(date)}
			</button>
		</td>
	);
}
